
import { apiSlice } from "@/redux/apiSlice";
import { ApiResponse } from "@/types";
import { Membership, MembeshipTable } from "@/types/system-setting/membership";

interface membershipInput {
  query?: string;
  org_id: number;
}
export const Memberships = apiSlice.injectEndpoints({
  endpoints(builder) {
    return {
      getMemberships: builder.query<
        MembeshipTable,
        membershipInput
      >({
        query: (searchCretiria) => ({
          url: `/membership_plan?${searchCretiria.query}`,
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }),
        providesTags: ["Memberships","Invoice", "Transaction","IncomeCategory","SysConfig"],
      }),
      createMemberships: builder.mutation<ApiResponse, Membership>({
        query: (membershipsdata) => ({
          url: `/membership_plan`,
          method: "POST",
          body: membershipsdata,
          headers: {
            Accept: "application/json",
          },
        }),
        invalidatesTags: ["Memberships","Invoice", "Transaction","IncomeCategory","SysConfig"],
      }),
      updateMemberships: builder.mutation<ApiResponse, Membership>({
        query: (membershipsdata) => ({
          url: `/membership_plan/${membershipsdata.id}`,
          method: "PUT",
          body: membershipsdata,
          headers: {
            Accept: "application/json",
          },
        }),
        invalidatesTags: ["Memberships","Invoice", "Transaction","IncomeCategory","SysConfig"],
      }),
      deleteMemberships: builder.mutation<ApiResponse, number>({
        query: (membership_id) => ({
          url: `/membership_plan/${membership_id}`,
          method: "DELETE",
          headers: {
            Accept: "application/json",
          },
        }),
        invalidatesTags: ["Memberships","Invoice", "Transaction","IncomeCategory","SysConfig"],
      }),
      getMembershipsById: builder.query<Membership, number>({
        query: (membership_id) => ({
          url: `/membership_plan/${membership_id}`,
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }),
        providesTags: ["Memberships","Invoice", "Transaction","IncomeCategory","SysConfig"],
      }),
      getMembershipList: builder.query<Membership[], { type?: "default" | "credit_add_ons" } | void>({
      query: (params) => ({
        url: `/membership_plan/list/`,
        method: "GET",
        params: {
          type: params?.type || "default",
        },
        headers: {
          Accept: "application/json",
        },
      }),
      providesTags: ["Memberships", "Invoice", "Transaction", "IncomeCategory", "SysConfig"],
    }),
    };
  },
});

export const {
  useGetMembershipsQuery,
  useCreateMembershipsMutation,
  useUpdateMembershipsMutation,
  useDeleteMembershipsMutation,
  useGetMembershipsByIdQuery,
  useGetMembershipListQuery,
} = Memberships;
